import * as React from 'react'
import { Formik } from 'formik'

import { validate } from './formConfig'
import { useData } from './useData'
import { Footer } from './Footer'
import { Content } from './Content'
import { WizardScreen } from '../WizardScreen'

export function LocAndSvcs() {
  const { onSubmit, initialValues, entityType, ...data } = useData()

  return (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      validateOnBlur={false}
      initialValues={initialValues}
    >
      <WizardScreen screen="locAndSvcs" footer={<Footer />} padding={0}>
        <Content {...data} />
      </WizardScreen>
    </Formik>
  )
}
